import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {components} from 'react-select';
import Select from 'react-select';
import {Field} from 'formik';
import arrowDown from '../../assets/arrow-select-black.svg';
import arrowDownActive from '../../assets/arrow-select-gold.svg';
import clear from '../../../modules/InspectedList/assets/cross.svg';
import styles from './styles.module.scss';

const Control = props => {
  return (
    <components.Control
      className={`${styles.control} ${props.isDisabled && styles.disabled} ${props.isFocused && styles.focus}`}  {...props}/>
  );
}


const DropdownIndicator = (props) => {
  return (props.isFocused)
      ? <img src={arrowDownActive} alt="dropdown arrow"/>
      : <img src={arrowDown} alt="dropdown arrow"/>
};

const IndicatorsContainer = props => (<components.IndicatorsContainer className={`${styles.indicatorsContainer} ${props.isDisabled && styles.disabled}`} {...props}/>);

const Input = props => <components.Input className={styles.input} {...props}/>;

const Placeholder = props => <components.Placeholder className={`${styles.placeholder} ${props.isDisabled && styles.disabled}`} {...props}/>;

const SingleValue = props => <components.SingleValue className={styles.input} {...props}/>;

const ValueContainer = customClassname => props => <components.ValueContainer className={classnames(styles.valueContainer, customClassname)} {...props}/>;

const Menu = props => <components.Menu className={styles.menu} {...props}/>;

const MenuList = props => <components.MenuList className={styles.menuList} {...props}/>;

const CustomOption = (props) => {
  return (
    <div className={styles.inputCheckboxContainer}>
      <components.Option {...props} className={styles.componentOption}>
        <div className={styles.checkboxContainer}>
          <input
            className={styles.input}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <div className={classnames(styles.checkbox, {
            [styles.checked]: props.isSelected,
          })}
          />
          <label className={styles.labelContainer}>
            {props.label}
          </label>
        </div>
      </components.Option>
    </div>
  );
};

const MultiValueRemove = (props) => {
  return false;
};

const CustomMultiValue = props => <components.MultiValueContainer className={styles.multiValueContainer} {...props}/>;

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        containerStyles,
                        label,
                        placeholder = 'בחר',
                        onChange,
                        onReset,
                        disabled,
                        options,
                        isSearchable = false,
                        showCross = false,
                        ...rest
                      }) => {
  const handleChange = (form, field) => option => {
    form.setFieldValue(field.name, option);
    if (onChange) {
      onChange(option);
    }
  };

  const handleReset = (form, field) => () => {
    form.setFieldValue(field.name, null);
    if (onReset) {
      onReset();
    }
  };

  const commonProps = {
    className: classnames(styles.select, {[styles.errorBorder]: meta.error && meta.touched}),
    value: field.value,
    onChange: handleChange(form, field),
    placeholder,
    isSearchable,
    isDisabled: disabled,
    components: {
      Control,
      DropdownIndicator,
      IndicatorSeparator: null,
      IndicatorsContainer,
      Input,
      Placeholder,
      SingleValue,
      ValueContainer: ValueContainer(showCross && styles.additionalPadding),
      Menu,
      MenuList,
      Option: CustomOption,
      MultiValueRemove,
      MultiValueContainer: CustomMultiValue
    },
    ...rest,
  };
  const props = {...commonProps, options};

  return (
    <div className={classnames(styles.selectContainer, containerStyles)}>
      {label && (
        <div className={styles.label}>
          {label}
        </div>
      )}
      <div className={styles.selectInnerWrapper}>
        <Select isMulti {...props} />
        {(!disabled) && showCross && (
          <img
            src={clear}
            className={styles.clearIcon}
            alt="clear-date"
            onClick={handleReset(form, field)}
          />
        )}
      </div>
    </div>
  );
};

const FieldSelectMulti = ({
                            fieldId,
                            ...rest
                          }) => (
  <Field
    id={fieldId}
    name={fieldId}
  >
    {fieldProps => <CustomSelect {...fieldProps} {...rest} />}
  </Field>
);

FieldSelectMulti.propTypes = {
  fieldId: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.node,
  containerStyles: PropTypes.string,
  onChange: PropTypes.func,
};

export default FieldSelectMulti;
